<template>
  <el-container class="new-post-container" style="width: 100%">
    <el-header class="page-header">
      <div class="header-content">
        <div class="header-left">
          <div class="title-row">
            <h2 style="text-align: left; margin: 0">{{ isEditing ? 'Edit Stack' : 'Create A New Stack' }}</h2>
            <div class="status-label" v-if="postForm.status">
              <template v-if="postForm.status === 'PRIVATE'">
                <i class="el-icon-lock"></i>
                <span style="font-weight: bold; color: #e6a23c">PRIVATE</span> - only visible to you
              </template>
              <template v-else-if="postForm.status === 'PUBLISHED'">
                <i class="el-icon-view"></i>
                <span style="font-weight: bold; color: #67c23a">PUBLISHED</span> - accessible to other users
              </template>
              <template v-else-if="postForm.status === 'PACKAGED'">
                <i class="el-icon-collection"></i>
                <span style="font-weight: bold; color: #409eff">PACKAGED</span> - part of a deck
              </template>
              <template v-else>
                <i class="el-icon-edit-outline"></i>
                Draft
              </template>
            </div>
          </div>
        </div>
        <div class="header-buttons">
          <template v-if="!collectionId || collectionId == null">
            <el-button type="primary" @click="updatePost" v-if="isEditing" :loading="isSaving" :disabled="isSaving">Save</el-button>
            <el-button type="primary" @click="savePost" v-if="isEditing && postForm.status != 'PUBLISHED' && postForm.status != 'PACKAGED'" :loading="isSaving" :disabled="isSaving">Save and Publish</el-button>
            <div style="margin: 8px 0; color: #909399; font-size: 14px;text-align: right;" v-if="!isEditing">
              <i class="el-icon-info" style="margin-right: 4px;"></i>
              Note: When you create a new knowit, you need to save it privately first (it can also work as a draft) before posting it publicly.
            </div>
            <el-button type="info" @click="saveDraft('PRIVATE')" v-if="(isEditing && postForm.status == 'PUBLISHED') || !isEditing" :loading="isSaving" :disabled="isSaving">Save as Private</el-button>
            
            <el-button @click="cancel">Cancel</el-button>
            <el-button v-if="isEditing" type="danger" @click="confirmDelete">Delete</el-button>
          </template>
          <template v-else>
            <span>{{collectionId}}</span>
            <el-button type="primary" @click="saveDraft('PACKAGED')" :loading="isSaving" :disabled="isSaving">Save In Deck</el-button>
            <el-button @click="cancel">Cancel</el-button>
          </template>
        </div>
      </div>
      <!-- <div v-if="hasQueryParams" class="query-params">
        <el-tag type="info">Collection ID: {{ collectionId }}</el-tag>
        <el-tag type="info">Group Index: {{ groupIndex }}</el-tag>
        <el-tag type="info">Knowit Index: {{ knowitIndex }}</el-tag>
      </div> -->
    </el-header>
    <!-- Floating Settings Button -->
    <!-- <el-button
      icon="el-icon-setting"
      style="position: fixed; top: 120px; right: 32px; z-index: 300; box-shadow: 0 2px 8px rgba(0,0,0,0.15);"
      @click="settingsDrawerVisible = true"
      circle
      type="primary"
    ></el-button> -->
    <!-- Settings Drawer -->

    <el-main style="width: 100%;">
      <el-form :model="postForm" :rules="rules" ref="postForm" label-position="top" style="width: 100%">
        <el-form-item label="Title" prop="title">
          <el-input v-model="postForm.title" placeholder="Enter your title"></el-input>
        </el-form-item>

        <el-tabs v-model="activeTab" style="margin-bottom: 24px;">
          <el-tab-pane label="Cards" name="contents">
            <!-- Multiple Answers Section -->
            <el-form-item prop="answers">
              <template slot="label">
                <span>Cards</span>
                <span class="cards-stats-inline">
                  <span class="stat-item-inline">
                    <span class="stat-label-inline">Total:</span>
                    <span class="stat-value-inline">{{ postForm.answers.length }}</span>
                  </span>
                </span>
              </template>

              <div class="tab-header">
                <div class="header-left-actions">
                  <el-button
                    type="primary"
                    icon="el-icon-sort"
                    @click="showResortDialog"
                  >
                    Resort Cards
                  </el-button>
                  <el-button
                    v-if="['Pro','Supreme'].includes(creator_functionality_level)"
                    type="primary"
                    icon="el-icon-magic-stick"
                    @click="handleAITask('Generate Knowit Cards')"
                  >
                    Generate Cards by AI
                  </el-button>
                  <el-button
                    v-if="['Pro','Supreme'].includes(creator_functionality_level)"
                    type="primary"
                    icon="el-icon-magic-stick"
                    @click="handleAITask('Generate on Custom Material')"
                  >
                    AI generation based on custom material
                  </el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="addNewAnswer"
                  >
                    Add New Card
                  </el-button>
                  <el-button
                    v-if="['Pro','Supreme'].includes(creator_functionality_level)"
                    type="primary"
                    icon="el-icon-magic-stick"
                    @click="handleAITask('Generate Single Knowit Content')"
                  >
                    AI Add New Card
                  </el-button>
                </div>

                <!-- Card Type Filter -->
                <div class="card-type-filter">
                  <el-select v-model="cardTypeFilter" size="small" placeholder="Filter by type" style="width: 150px;">
                    <el-option label="All Types" value="all"></el-option>
                    <el-option label="Text" value="text">
                      <i class="el-icon-document"></i> Text
                    </el-option>
                    <el-option label="Quiz" value="quiz">
                      <i class="el-icon-question"></i> Quiz
                    </el-option>
                    <el-option label="Image" value="image">
                      <i class="el-icon-picture"></i> Image
                    </el-option>
                    <el-option label="Video" value="video">
                      <i class="el-icon-video-camera"></i> Video
                    </el-option>
                    <el-option label="YouTube" value="youtube">
                      <i class="el-icon-video-play"></i> YouTube
                    </el-option>
                  </el-select>
                </div>

                <!-- Layout Switcher -->
                <div class="layout-switcher">
                  <el-radio-group v-model="layoutMode" size="small">
                    <el-radio-button label="grid">
                      <i class="el-icon-s-grid"></i> Grid
                    </el-radio-button>
                    <el-radio-button label="paragraph">
                      <i class="el-icon-menu"></i> Paragraph
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>

              <!-- Cards Grid Layout -->
              <div v-if="layoutMode === 'grid'" class="cards-grid" ref="gridContainer">
                <PostAnswerView
                  v-for="(answer, filteredIndex) in filteredAnswers"
                  :key="`answer-${answer.uniqueCode || postForm.answers.indexOf(answer)}`"
                  :answer="answer"
                  :index="postForm.answers.indexOf(answer)"
                  @edit="editAnswer(postForm.answers.indexOf(answer))"
                  @update="updateAnswer(postForm.answers.indexOf(answer), $event)"
                  @delete="removeAnswer(postForm.answers.indexOf(answer))"
                  @click="editAnswer(postForm.answers.indexOf(answer))"
                  class="card-item"
                  :data-index="postForm.answers.indexOf(answer)"
                />
              </div>

              <!-- Paragraph Layout -->
              <div v-else-if="layoutMode === 'paragraph'" class="paragraph-layout" ref="paragraphContainer">
                <div
                  v-for="(answer, filteredIndex) in filteredAnswers"
                  :key="`para-answer-${answer.uniqueCode || postForm.answers.indexOf(answer)}`"
                  class="paragraph-item"
                  :data-index="postForm.answers.indexOf(answer)"
                >
                  <div class="paragraph-header">
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <i class="el-icon-rank drag-handle" style="font-size: 18px; color: #909399; cursor: move;"></i>
                      <span class="paragraph-number">Card #{{ postForm.answers.indexOf(answer) + 1 }}</span>
                    </div>
                    <div class="paragraph-actions">
                      <el-button
                        type="text"
                        icon="el-icon-edit"
                        @click="editAnswer(postForm.answers.indexOf(answer))"
                        size="small"
                      >
                        Edit
                      </el-button>
                      <el-button
                        v-if="answer.content_type === 'quiz'"
                        type="text"
                        icon="el-icon-magic-stick"
                        @click="handleFixByAIForCard(postForm.answers.indexOf(answer))"
                        size="small"
                        style="color: #409EFF;"
                      >
                        Fix by AI
                      </el-button>
                      <el-button
                        v-if="!answer.content_type || answer.content_type === 'text'"
                        type="text"
                        icon="el-icon-magic-stick"
                        @click="openAIModifyDialog(postForm.answers.indexOf(answer))"
                        size="small"
                        style="color: #409EFF;"
                      >
                        AI Modify
                      </el-button>
                      <el-button
                        type="text"
                        icon="el-icon-delete"
                        @click="removeAnswer(postForm.answers.indexOf(answer))"
                        size="small"
                        style="color: #f56c6c;"
                      >
                        Delete
                      </el-button>
                    </div>
                  </div>

                  <div class="paragraph-content">
                    <!-- Text Content -->
                    <template v-if="!answer.content_type || answer.content_type === 'text'">
                      <div class="text-content" v-html="renderMarkdown(answer.content)"></div>
                    </template>

                    <!-- Image Content -->
                    <template v-else-if="answer.content_type === 'image'">
                      <div class="image-content">
                        <img v-if="answer.fileList && answer.fileList.length > 0"
                          :src="answer.fileList[0].url"
                          :alt="'Answer Image'"
                        >
                      </div>
                    </template>

                    <!-- Video Content -->
                    <template v-else-if="answer.content_type === 'video'">
                      <div class="video-content">
                        <video v-if="answer.fileList && answer.fileList.length > 0" controls>
                          <source :src="answer.fileList[0].url" :type="answer.fileList[0].mime_type">
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </template>

                    <!-- YouTube Content -->
                    <template v-else-if="answer.content_type === 'youtube'">
                      <div class="youtube-content">
                        <iframe
                          v-if="extractYoutubeId(answer.content)"
                          :src="'https://www.youtube.com/embed/' + extractYoutubeId(answer.content)"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                          style="width: 100%; aspect-ratio: 16/9; border-radius: 8px;"
                        ></iframe>
                      </div>
                    </template>

                    <!-- Quiz Content -->
                    <template v-else-if="answer.content_type === 'quiz'">
                      <div class="quiz-content">
                        <div class="quiz-question"><strong>Question:</strong> {{ answer.quiz_content.question }}</div>
                        <div v-for="(option, idx) in answer.quiz_content.options.filter(option => option !== '')" :key="idx" class="quiz-option">
                          <span style="min-width: 30px;">{{ ['A','B','C','D'][idx] }}.</span>
                          <span>{{ option }}</span>
                        </div>
                        <div v-if="answer.quiz_content.explanation" class="quiz-explanation">
                          <strong>Explanation:</strong> {{ answer.quiz_content.explanation }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <!-- Content Summary Section -->
              <div v-if="postForm.answers.length > 0" class="content-summary-section">
                <div class="summary-header">
                  <h3>Takeaway Summary</h3>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-magic-stick"
                    @click="updateSummaryByAI"
                    :loading="isGeneratingSummary"
                    :disabled="isGeneratingSummary"
                  >
                    {{ isGeneratingSummary ? 'Generating...' : 'Update by AI' }}
                  </el-button>
                </div>
                <div class="summary-note">
                  <i class="el-icon-info"></i>
                  The Takeaway Summary can be saved as a default card for quick noting and reminding.
                </div>
                <el-input
                  type="textarea"
                  v-model="postForm.content_summary"
                  :rows="6"
                  placeholder="Add a summary of the content in this stack..."
                  :disabled="isGeneratingSummary"
                ></el-input>
              </div>

              <div v-if="filteredAnswers.length === 0 && postForm.answers.length === 0" class="empty-state">
                <p>No cards added yet.</p>
                <el-button type="primary" @click="addNewAnswer">
                  Create Your First Card
                </el-button>
              </div>
              <div v-else-if="filteredAnswers.length === 0 && postForm.answers.length > 0" class="empty-state">
                <p>No cards match the selected filter.</p>
                <el-button type="primary" @click="cardTypeFilter = 'all'">
                  Clear Filter
                </el-button>
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Stack Settings" name="settings">
            <el-form label-position="top" style="margin-top: 16px;">
              <el-form-item label="Visibility Status">
                <el-switch
                  v-model="postForm.visibility_status"
                  active-text="Public"
                  inactive-text="Hidden"
                  active-value="public"
                  inactive-value="hidden"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <div style="margin-top: 8px; font-size: 13px; color: #909399;">
                  <template v-if="postForm.visibility_status === 'public'">
                    <i class="el-icon-view"></i> This stack is visible to users who have access to the collection
                  </template>
                  <template v-else>
                    <i class="el-icon-warning"></i> This stack is hidden and will not be shown to users, even if they have access to the collection
                  </template>
                </div>
              </el-form-item>

              <el-form-item label="Custom Display Date">
                <el-date-picker
                  v-model="customDisplayDate"
                  type="datetime"
                  placeholder="Select custom display date"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="timestamp"
                  style="width: 100%;"
                  clearable
                >
                </el-date-picker>
                <div style="margin-top: 8px; font-size: 13px; color: #909399;">
                  <i class="el-icon-info"></i> Set a custom date to override the default create/update date for display purposes. Leave empty to use the actual date.
                </div>
              </el-form-item>

              <template v-if="!postForm.collection_id || collectionId == '' || postForm.status != 'PACKAGED'">
                <el-form-item label="Access Type for Cryptic Cards">
                  <el-radio-group v-model="postForm.access_type">
                    <!-- <el-radio label="free">Free access</el-radio> -->
                    <!-- <el-radio label="token">By paying token</el-radio> -->

                    <el-radio label="token">By paying Knowit credits</el-radio>
                    <el-radio label="subscriber">Subscribers only</el-radio>

                  </el-radio-group>
                </el-form-item>
                <el-form-item label="Credit Price (1 Knowit credit = $0.01 USD)" prop="token_price" v-if="postForm.access_type === 'token'">
                  <el-input-number
                    v-model="postForm.token_price"
                    :min="1"
                    :precision="0"
                    :step="1"
                    placeholder="Enter credit price"
                  ></el-input-number>
                </el-form-item>
                <!-- Need to add Subscription Program selection here -->
              </template>
            </el-form>

          </el-tab-pane>
        </el-tabs>

        
      </el-form>
    </el-main>

    <!-- Update AI Dialog implementation -->
    <ai-dialog
      v-model="aiDialogVisible"
      :visible="aiDialogVisible"
      :taskType="currentAITask"
      @update:visible="aiDialogVisible = $event"
      @use="handleAIResult"
      :initialInput="aiDialogInitialInput"
      :context-string="aiContextString"
    />

    <!-- Floating AI Button on Right Edge -->
    <div class="floating-ai-button" @click="openAIDrawer()">
      <i class="el-icon-magic-stick"></i>
      <span>AI Assistant</span>
    </div>

    <!-- AI Assistant Drawer for Post Editing -->
    <el-drawer
      title="AI Knowit Assistant"
      :visible.sync="aiDrawerVisible"
      direction="rtl"
      size="80%"
      :modal="false"
      :show-close="true"
      :wrapperClosable="false"
      :before-close="handleDrawerClose"
      custom-class="ai-post-drawer"
      :with-header="true"
    >
      <UserAIDialogue 
        :context_string="getAIContextString()"
        :context_pot="globalContextPot"
        :task-type="currentAITask"
        :current_chain_id="chain_id"
        @use="handleAIResult"
        @clear-context-pot="clearContextPot"
        @remove-from-pot="removeFromContextPot"
      />
    </el-drawer>

    <!-- Edit Post Answer Dialog -->
    <EditPostAnswer
      :visible.sync="editCardDialogVisible"
      :answer="editingAnswer"
      @save="saveEditedAnswer"
      @close="closeEditDialog"
    />

    <!-- Keep existing dialog -->
    <el-dialog
      title="Confirm Delete"
      :visible.sync="deleteDialogVisible"
      width="30%">
      <span>Are you sure you want to delete this stack?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">Cancel</el-button>
        <el-button type="danger" @click="deletePost">Delete</el-button>
      </span>
    </el-dialog>

    <!-- Add resort dialog -->
    <el-dialog
      title="Resort Cards"
      :visible.sync="resortDialogVisible"
      width="60%"
    >
      <el-table
        :data="sortableAnswers"
        row-key="uniqueCode"
        style="width: 100%"
      >
        <el-table-column width="40">
          <template slot-scope="scope">
            <i 
              class="el-icon-rank" 
              style="cursor: move; color: #909399;"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="Type" width="120">
          <template slot-scope="scope">
            {{ scope.row.content_type.toUpperCase() }}
          </template>
        </el-table-column>
        <el-table-column label="Content Preview">
          <template slot-scope="scope">
            <span v-if="scope.row.content_type === 'text'">
              {{ scope.row.content.substring(0, 100).replace(/<[^>]*>/g, '') }}...
            </span>
            <span v-else-if="scope.row.content_type === 'quiz'">
              {{ scope.row.quiz_content.question.substring(0, 100) }}...
            </span>
            <span v-else>
              {{ scope.row.content_type }} content
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resortDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="applyResort">Confirm</el-button>
      </span>
    </el-dialog>

    <!-- AI Fix Comparison Dialog -->
    <el-dialog
      title="AI Fix Comparison"
      :visible.sync="showComparisonDialog"
      width="80%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :append-to-body="true"
    >
      <div class="comparison-container">
        <div class="comparison-column">
          <h3>Original Card</h3>
          <div class="card-preview">
            <template v-if="fixingCardData">
              <template v-if="fixingCardData.content_type === 'quiz' && fixingCardData.quiz_content">
                <div class="quiz-display">
                  <div class="quiz-question-display">
                    <strong>Question:</strong> {{ fixingCardData.quiz_content.question }}
                  </div>
                  <div class="quiz-options-display">
                    <div v-for="(option, idx) in fixingCardData.quiz_content.options.filter(opt => opt !== '')" :key="idx"
                         :class="['quiz-option-display', { 'correct': fixingCardData.quiz_content.correct_answer === ['A','B','C','D'][idx] }]">
                      <span>{{ ['A','B','C','D'][idx] }}. {{ option }}</span>
                      <i v-if="fixingCardData.quiz_content.correct_answer === ['A','B','C','D'][idx]" class="el-icon-check"></i>
                    </div>
                  </div>
                  <div class="quiz-explanation-display" v-if="fixingCardData.quiz_content.explanation">
                    <strong>Explanation:</strong> {{ fixingCardData.quiz_content.explanation }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-content" v-html="renderMarkdown(fixingCardData.content)"></div>
              </template>
            </template>
          </div>
        </div>

        <div class="comparison-column">
          <h3>AI Suggestion</h3>
          <div class="card-preview">
            <template v-if="isLoadingAI">
              <div class="loading-state">
                <i class="el-icon-loading" style="font-size: 32px; color: #409EFF;"></i>
                <p>AI is analyzing the card...</p>
              </div>
            </template>
            <template v-else-if="aiResponse">
              <template v-if="aiResponse.trim().toLowerCase() === 'true'">
                <div class="no-defects-state">
                  <i class="el-icon-circle-check" style="font-size: 48px; color: #67c23a;"></i>
                  <p style="font-size: 16px; font-weight: 500; margin-top: 16px;">No defects found!</p>
                  <p style="color: #909399;">This card is already correct and doesn't need any fixes.</p>
                </div>
              </template>
              <template v-else>
                <div class="quiz-display" v-if="parsedAIResponse">
                  <div class="quiz-question-display">
                    <strong>Question:</strong> {{ parsedAIResponse.quiz_content.question }}
                  </div>
                  <div class="quiz-options-display">
                    <div v-for="(option, idx) in parsedAIResponse.quiz_content.options.filter(opt => opt !== '')" :key="idx"
                         :class="['quiz-option-display', { 'correct': parsedAIResponse.quiz_content.correct_answer === ['A','B','C','D'][idx] }]">
                      <span>{{ ['A','B','C','D'][idx] }}. {{ option }}</span>
                      <i v-if="parsedAIResponse.quiz_content.correct_answer === ['A','B','C','D'][idx]" class="el-icon-check"></i>
                    </div>
                  </div>
                  <div class="quiz-explanation-display" v-if="parsedAIResponse.quiz_content.explanation">
                    <strong>Explanation:</strong> {{ parsedAIResponse.quiz_content.explanation }}
                  </div>
                </div>
                <div v-else class="error-state">
                  <i class="el-icon-warning" style="font-size: 32px; color: #f56c6c;"></i>
                  <p>Failed to parse AI response</p>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAIFix" v-if="!aiResponse || aiResponse.trim().toLowerCase() !== 'true'">Cancel</el-button>
        <el-button
          type="primary"
          @click="confirmAIFix"
          :disabled="isLoadingAI || !aiResponse"
        >
          {{ aiResponse && aiResponse.trim().toLowerCase() === 'true' ? 'OK' : 'Apply AI Fixes' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- AI Modify Text Card Dialog -->
    <el-dialog
      title="AI Modify Card"
      :visible.sync="showAIModifyDialog"
      width="70%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <div class="ai-modify-container">
        <!-- Step 1: Enter instruction -->
        <template v-if="!aiModifyResponse">
          <div class="ai-modify-instruction">
            <div class="original-content-preview">
              <h4>Current Card Content:</h4>
              <div class="content-preview-box" v-html="renderMarkdown(modifyingCardData ? modifyingCardData.content : '')"></div>
            </div>
            <div class="instruction-input">
              <h4>Enter your modification instruction:</h4>
              <el-input
                type="textarea"
                v-model="aiModifyInstruction"
                placeholder="e.g., Make this more concise, Add more examples, Translate to Chinese, Fix grammar errors, Make it more formal..."
                :autosize="{ minRows: 3, maxRows: 6 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </div>
          </div>
        </template>

        <!-- Step 2: Show comparison -->
        <template v-else>
          <div class="comparison-container">
            <div class="comparison-column">
              <h3>Original</h3>
              <div class="card-preview">
                <div class="text-content" v-html="renderMarkdown(modifyingCardData ? modifyingCardData.content : '')"></div>
              </div>
            </div>
            <div class="comparison-column">
              <h3>AI Modified</h3>
              <div class="card-preview">
                <template v-if="isLoadingAIModify">
                  <div class="loading-state">
                    <i class="el-icon-loading" style="font-size: 32px; color: #409EFF;"></i>
                    <p>AI is modifying the card...</p>
                  </div>
                </template>
                <template v-else>
                  <div class="text-content" v-html="renderMarkdown(aiModifyResponse)"></div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAIModify">Cancel</el-button>
        <template v-if="!aiModifyResponse">
          <el-button
            type="primary"
            @click="executeAIModify"
            :loading="isLoadingAIModify"
            :disabled="!aiModifyInstruction || aiModifyInstruction.trim() === ''"
          >
            Modify by AI
          </el-button>
        </template>
        <template v-else>
          <el-button @click="resetAIModify">Try Again</el-button>
          <el-button
            type="primary"
            @click="applyAIModify"
            :disabled="isLoadingAIModify"
          >
            Apply Changes
          </el-button>
        </template>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { postRequest } from '@/apis/front'
import axios from 'axios'
import * as qiniu from "qiniu-js";
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import AIDialog from '@/components/AIDialog.vue'
import UserAIDialogue from '@/components/UserAIDialogue.vue'
import TextCanvas from '@/components/TextCanvas.vue'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Sortable from 'sortablejs/modular/sortable.core.esm.js'
import PostAnswerView from '@/components/PostAnswerView.vue'
import EditPostAnswer from '@/components/EditPostAnswer.vue'
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  name: 'NewPost',
  components: {
    mavonEditor,
    'ai-dialog': AIDialog,
    UserAIDialogue,
    TextCanvas,
    quillEditor,
    PostAnswerView,
    EditPostAnswer
  },
  data() {
    return {
      creator_functionality_level: this.$store.state.user_info.creator_functionality_level,
      activeTab: 'contents',
      isEditing: false,
      postId: '',
      deleteDialogVisible: false,
      postForm: {
        title: '',
        description: '',
        answers: [],
        status: '',
        usd_price: 0,
        token_price: 0,
        access_type: 'exchange',
        visibility_status: 'public',
        content_summary: ''
      },
      settingsDrawerVisible: false,
      rules: {
        title: [
          { required: true, message: 'Please input a title', trigger: 'blur' },
          { min: 3, max: 100, message: 'Length should be 3 to 100 characters', trigger: 'blur' }
        ],
        content: [
          { required: true, message: 'Please input content', trigger: 'blur' },
          { min: 10, message: 'Content should be at least 10 characters', trigger: 'blur' }
        ],
        answers: [
          { 
            type: 'array', 
            required: true, 
            message: 'Please add at least one content',
            trigger: 'change'
          }
        ],
        token_price: [
          { required: true, message: 'Please input a price', trigger: 'blur' }
        ]
      },
      collectionId: null,
      groupIndex: null,
      knowitIndex: null,
      markdownToolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        help: true,
        preview: true
      },
      aiDialogVisible: false,
      currentAITask: '',
      aiDialogInitialInput: '',
      aiContextString: '',
      aiAnswerEditIndex: null,
      collectionContextString: '',
      activeInsertIndex: null,
      resortDialogVisible: false,
      sortableAnswers: [],
      autoSaveDebounceTimer: null,
      editCardDialogVisible: false,
      editingAnswer: null,
      editingAnswerIndex: null,
      aiDrawerVisible: false,
      showComparisonDialog: false,
      aiResponse: null,
      isLoadingAI: false,
      fixingCardIndex: null,
      fixingCardData: null,
      // AI Modify Text Card
      showAIModifyDialog: false,
      modifyingCardIndex: null,
      modifyingCardData: null,
      aiModifyInstruction: '',
      aiModifyResponse: null,
      isLoadingAIModify: false,
      isGeneratingSummary: false,
      isSaving: false, // Loading state for save buttons
      chain_id: '',
      layoutMode: 'grid', // 'grid' or 'paragraph'
      cardTypeFilter: 'all', // Filter for card types: 'all', 'text', 'quiz', 'image', 'video'
      customDisplayDate: null, // Timestamp for custom display date
      gridSortable: null, // Sortable instance for grid layout
      paragraphSortable: null, // Sortable instance for paragraph layout
    }
  },
  computed: {
    globalContextPot() {
      return this.$store.state.contextPot.items;
    },
    hasQueryParams() {
      return this.collectionId || this.groupIndex || this.knowitIndex
    },
    isCreator() {
      return this.postForm.user_id === this.$store.state.user_id;
    },
    filteredAnswers() {
      if (this.cardTypeFilter === 'all') {
        return this.postForm.answers;
      }
      return this.postForm.answers.filter(answer => {
        const contentType = answer.content_type || 'text';
        return contentType === this.cardTypeFilter;
      });
    },
    parsedAIResponse() {
      if (!this.aiResponse || this.aiResponse.trim().toLowerCase() === 'true') {
        return null
      }
      try {
        return JSON.parse(this.aiResponse)
      } catch (error) {
        return null
      }
    }
  },
  created() {
    // Clean up old auto-save caches from other users
    this.$nextTick(() => {
      this.cleanupOldAutoSaveCaches();
    });

    // Add query parameter handling
    console.log(this.$route.params)
    this.collectionId = this.$route.params.collectionId
    this.groupIndex = this.$route.params.groupIndex
    this.knowitIndex = this.$route.params.knowitIndex
    this.collectionContextString = this.$route.params.collectionContextString

    // Log all index parameters for debugging
    console.log('POST Collection ID:', this.collectionId)
    console.log('POST Group Index:', this.groupIndex)
    console.log('POST Knowit Index:', this.knowitIndex)

    // Initialize with one empty answer if creating new post
    if (!this.isEditing) {
      this.addNewAnswer()
    }

    // Check for post ID in both route query and localStorage
    const queryPostId = this.$route.params.postId
    const storedPostId = localStorage.getItem('editPostId')

    console.log('queryPostId:', queryPostId)
    console.log('storedPostId:', storedPostId)
    
    if (queryPostId && (queryPostId.length == 24 || queryPostId == 'new')) {
      // Router query takes precedence - update localStorage
      console.log('queryPostId:', queryPostId)
      
      this.postId = queryPostId

      localStorage.setItem('editPostId', queryPostId)
      if(queryPostId.length == 24){
        this.isEditing = true
        this.fetchPostData(queryPostId)
      }
    } else if (storedPostId && storedPostId.length == 24) {
      // Fall back to localStorage if no query parameter
      console.log('storedPostId 2:', storedPostId)
      this.isEditing = true
      this.postId = storedPostId
      this.fetchPostData(storedPostId)
    }
    console.log('query PostForm:', JSON.stringify(this.$route.params))

    // If no post ID but postForm data exists in route params, initialize form
    if (!this.isEditing && this.$route.params.postForm) {
      // Iterate through postForm params and copy to this.postForm
      const paramPostForm = this.$route.params.postForm
      if (paramPostForm) {
        Object.keys(paramPostForm).forEach(key => {
          this.postForm[key] = paramPostForm[key]
        })
      }
      console.log('postForm:', this.postForm)
    }
    this.checkAutoSavePrompt();
  },
  mounted() {
    // Force layout recalculation
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'));
      // Initialize drag-and-drop for answers
      this.initAnswerSortable();
    });
  },
  watch: {
    layoutMode() {
      // Reinitialize sortable when layout mode changes
      this.$nextTick(() => {
        this.destroySortable();
        this.initAnswerSortable();
      });
    }
  },
  beforeDestroy() {
    this.destroySortable();
  },
  methods: {
    initAnswerSortable() {
      if (this.layoutMode === 'grid' && this.$refs.gridContainer) {
        this.gridSortable = Sortable.create(this.$refs.gridContainer, {
          animation: 150,
          handle: '.card-item',
          draggable: '.card-item',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          onEnd: (evt) => {
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (oldIndex !== newIndex) {
              // Reorder the answers array
              const movedItem = this.postForm.answers.splice(oldIndex, 1)[0];
              this.postForm.answers.splice(newIndex, 0, movedItem);
              this.$message.success('Content order updated');
            }
          }
        });
      } else if (this.layoutMode === 'paragraph' && this.$refs.paragraphContainer) {
        this.paragraphSortable = Sortable.create(this.$refs.paragraphContainer, {
          animation: 150,
          handle: '.paragraph-item',
          draggable: '.paragraph-item',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          onEnd: (evt) => {
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (oldIndex !== newIndex) {
              // Reorder the answers array
              const movedItem = this.postForm.answers.splice(oldIndex, 1)[0];
              this.postForm.answers.splice(newIndex, 0, movedItem);
              this.$message.success('Content order updated');
            }
          }
        });
      }
    },
    destroySortable() {
      if (this.gridSortable) {
        this.gridSortable.destroy();
        this.gridSortable = null;
      }
      if (this.paragraphSortable) {
        this.paragraphSortable.destroy();
        this.paragraphSortable = null;
      }
    },
    generateUniqueCode() {
      const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const dateStr = new Date().toISOString().slice(0,10).replace(/-/g,''); // YYYYMMDD
      
      let code;
      do {
        code = '';
        for (let i = 0; i < 4; i++) {
          code += chars.charAt(Math.floor(Math.random() * chars.length));
        }
      } while (this.postForm.answers.some(answer => answer.uniqueCode && answer.uniqueCode.slice(-4) === code));

      return `${dateStr}${code}`;
    },

    extractYoutubeId(url) {
      if (!url) return ''
      const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
        /^([a-zA-Z0-9_-]{11})$/
      ]
      for (const pattern of patterns) {
        const match = url.match(pattern)
        if (match) return match[1]
      }
      return ''
    },

    renderMarkdown(content) {
      if (!content) return '';
      const rawHtml = marked.parse(content);
      return DOMPurify.sanitize(rawHtml);
    },

    async beforeFileUpload(file,answerIndex){
      let file_type = file.type;
      let answer_content_type = this.postForm.answers[answerIndex].content_type
      let fileValid = false
      if(answer_content_type == 'image') {
        if(file_type == 'image/jpeg' || file_type == 'image/png'){
          fileValid = true
        }
      }
      if(answer_content_type == 'video') {
        const videoMimeTypes = [
          'video/mp4',
          'video/webm',
          'video/ogg',
          'video/*' // 匹配任何视频子类型
        ];
        fileValid =  videoMimeTypes.includes(file_type)
      }
      if(fileValid == false){
         this.$message.warning('File type is not correct.')
         return
      }

      // Check file size limit (5MB)
      if(file.size > 5 * 1024 * 1024){
        this.$message.error('File size should be less than 5MB')
        return
      }

      // Compress image if needed (for images larger than 500KB)
      let processedFile = file
      if(answer_content_type == 'image' && file.size > 500 * 1024) {
        this.$message.info('Compressing image...')
        try {
          processedFile = await this.compressImage(file, 1024 * 1024) // Target max 1MB
        } catch (error) {
          this.$message.error('Failed to compress image')
          console.error('Compression error:', error)
          return
        }
      }

      const tokenResponse = await postRequest('getSingaporeQiniuToken', {  })
      let token = tokenResponse.data.data
      // Let Qiniu auto-generate hash-based key
      let qiniuKey = null
      const putExtra = {
        fname: processedFile.name,
        mimeType: processedFile.type
      }
      const config = {
        useCdnDomain: true
      }
      let observable = qiniu.upload(processedFile, qiniuKey, token, putExtra, config)
      const observer = {
        complete: (res) => {
          let url = "https://ap.knowit.today/" + res.key;
          this.postForm.answers[answerIndex].fileList.push({url:url,name:processedFile.name, mime_type:answer_content_type})
        }
      }
      observable.subscribe(observer)
    },

    async compressImage(file, maxSize) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          const img = new Image()
          img.src = e.target.result
          img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')

            // Calculate new dimensions while maintaining aspect ratio
            let width = img.width
            let height = img.height

            // Start with reasonable max dimensions (1920x1920)
            const maxDimension = 1920
            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = Math.round((height * maxDimension) / width)
                width = maxDimension
              } else {
                width = Math.round((width * maxDimension) / height)
                height = maxDimension
              }
            }

            canvas.width = width
            canvas.height = height
            ctx.drawImage(img, 0, 0, width, height)

            // Try different quality levels to reach target size
            let quality = 0.9
            const tryCompress = () => {
              canvas.toBlob((blob) => {
                if (blob.size <= maxSize || quality <= 0.5) {
                  // Success or reached minimum quality
                  const compressedFile = new File([blob], file.name, {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                  })
                  const sizeMB = (blob.size / (1024 * 1024)).toFixed(2)
                  this.$message.success(`Image compressed to ${sizeMB}MB`)
                  resolve(compressedFile)
                } else {
                  // Try again with lower quality
                  quality -= 0.1
                  tryCompress()
                }
              }, 'image/jpeg', quality)
            }

            tryCompress()
          }
          img.onerror = () => reject(new Error('Failed to load image'))
        }
        reader.onerror = () => reject(new Error('Failed to read file'))
      })
    },


    async fetchPostData(postId) {
      try {
        const response = await postRequest('getPost', { post_id: postId, user_id: this.$store.state.user_id })
        if (response.data.code === 0) {
          const postData = response.data.data

          // Verify the post belongs to the current user
          const currentUserId = this.$store.state.user_id;
          if (postData.user_id && postData.user_id !== currentUserId) {
            // Post belongs to a different user, clear stored ID and reset
            this.$message.warning("This stack belongs to another user. Starting a new stack.");
            localStorage.removeItem('editPostId');
            this.isEditing = false;
            this.postId = '';
            return;
          }

          // Initialize required properties for any existing answers
          if (postData.answers) {
            postData.answers.forEach(answer => {
              // Initialize is_hidden if not present
              if (answer.is_hidden === undefined) {
                this.$set(answer, 'is_hidden', false)
              }
              // Initialize quiz_content for quiz type answers
              if (answer.content_type === 'quiz' && !answer.quiz_content) {
                this.$set(answer, 'quiz_content', {
                  question: '',
                  options: ['', '', '', ''],
                  correct_answer: '',
                  explanation: ''
                })
              }
            })
          }

          // IMPORTANT: Route params take precedence over database values!
          // Route params represent the CURRENT position user clicked on.
          // Only use database values if route params weren't provided.
          if(postData.collection_id && postData.collection_id.length == 24){
            // Only set collectionId from DB if not already set from route params
            if (!this.collectionId) {
              this.collectionId = postData.collection_id
              console.log('postData.collection_id (from DB):', postData.collection_id)
            } else {
              console.log('collectionId already set from route params:', this.collectionId, '(DB value:', postData.collection_id, ')')
            }
          }

          if(postData.group_index >= 0){
            // Only set groupIndex from DB if not already set from route params
            if (this.groupIndex === null || this.groupIndex === undefined) {
              this.groupIndex = postData.group_index
              console.log('postData.group_index (from DB):', postData.group_index)
            } else {
              console.log('groupIndex already set from route params:', this.groupIndex, '(DB value:', postData.group_index, ')')
            }
          }

          if(postData.post_index >= 0){
            // Only set knowitIndex from DB if not already set from route params
            if (this.knowitIndex === null || this.knowitIndex === undefined) {
              this.knowitIndex = postData.post_index
              console.log('postData.post_index (from DB):', postData.post_index)
            } else {
              console.log('knowitIndex already set from route params:', this.knowitIndex, '(DB value:', postData.post_index, ')')
            }
          }

          // Load custom display date if exists (convert from seconds to milliseconds)
          if (postData.custom_display_date) {
            this.customDisplayDate = postData.custom_display_date * 1000;
          }

          this.postForm = postData

          console.log('postForm:', this.postForm)
        } else {
          throw new Error(response.data.msg || 'Failed to load knowit')
        }
      } catch (error) {
        this.$message.error('Failed to load knowit data')
        console.error('Error fetching post:', error)
        // Clear invalid post ID
        localStorage.removeItem('editPostId');
        this.isEditing = false;
        this.postId = '';
      }
    },
    // Clean object keys by trimming spaces
    cleanObjectKeys(obj) {
      if (obj === null || obj === undefined) {
        return obj;
      }

      if (Array.isArray(obj)) {
        return obj.map(item => this.cleanObjectKeys(item));
      }

      if (typeof obj === 'object') {
        const cleaned = {};
        Object.keys(obj).forEach(key => {
          const trimmedKey = key.trim();
          cleaned[trimmedKey] = this.cleanObjectKeys(obj[key]);
        });
        return cleaned;
      }

      return obj;
    },

    async updatePost(silentSave = false) {
      // Don't set loading state for silent saves (auto-save from card edit)
      if (!silentSave) {
        this.isSaving = true;
      }

      try {
        // Add validation to ensure all answers have unique codes
        this.postForm.answers.forEach(answer => {
          if (!answer.uniqueCode) {
            answer.uniqueCode = this.generateUniqueCode();
          }
        });

        console.log('SUBMIT groupIndex:', this.groupIndex);
        console.log('SUBMIT knowitIndex:', this.knowitIndex);
        const params = {
          id: this.postId || '',
          user_id: this.isEditing ? this.postForm.user_id : this.$store.state.user_id,
          title: this.postForm.title,
          description: this.postForm.description,
          content_type: this.postForm.content_type,
          answers: this.postForm.answers,
          price: this.postForm.price,
          labels: [],
          status: this.postForm.status,
          usd_price: this.postForm.usd_price,
          token_price: this.postForm.token_price,
          collection_id: this.collectionId || '',
          group_index: this.groupIndex !== undefined ? this.groupIndex : '',
          post_index: this.knowitIndex !== undefined ? this.knowitIndex : '',
          access_type: this.collectionId && this.collectionId !== '' ? 'collection' : this.postForm.access_type,
          visibility_status: this.postForm.visibility_status || 'public',
          custom_display_date: this.customDisplayDate ? Math.floor(this.customDisplayDate / 1000) : null,
          content_summary: this.postForm.content_summary || ''
        }

        // Clean all object keys to remove spaces
        const cleanedParams = this.cleanObjectKeys(params);

        const response = await postRequest('updatePost', cleanedParams)

        if (response.data.code === 0) {
          this.clearAutoSaveCache();

          // If silent save (auto-save), don't navigate away
          if (silentSave) {
            // For new posts, get and set the ID from response data
            if (!this.postId || this.postId === "") {
              const newPostId = (response.data.data._id.$oid || response.data.data._id.$id);
              this.postId = newPostId;
              localStorage.setItem('editPostId', newPostId);
            }
            return true;
          }

          // Handle navigation with catch block
          try {
            console.log('4'+this.collectionId)

            // For new posts, get and set the ID from response data
            if (!this.postId || this.postId === "") {
              const newPostId = (response.data.data._id.$oid || response.data.data._id.$id);
              this.postId = newPostId;
              localStorage.setItem('editPostId', newPostId);
            }
            if (this.collectionId) {
              console.log('5'+this.collectionId)
              localStorage.setItem('editCollectionId', this.collectionId)
              // this.$router.push('/new-collection')



              //这里要有实现把Knowit加进去的代码

              return false
            } else {
              this.$router.go(-1)

            }

          } catch (err) {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          }
        } else {
          this.$message.error(response.msg || 'Failed to save knowit')
          throw new Error(response.msg || 'Failed to save knowit')
        }
      } finally {
        if (!silentSave) {
          this.isSaving = false;
        }
      }
    },

    async createPrivatePostFromAI(postData) {
      console.log('createPrivatePostFromAI called with:', postData);
      try {
        // Create a new knowit form based on the AI-generated data
        const newPost = {
          id: '', // Empty for new post
          user_id: this.$store.state.user_id,
          title: postData.title || 'AI Generated Content',
          description: postData.description || 'Content generated by AI',
          content_type: postData.content_type || 'multiple_choice',
          answers: [],
          price: 0,
          labels: [],
          status: 'PRIVATE', // Set as private
          usd_price: 0,
          token_price: 0,
          collection_id: '',
          group_index: '',
          post_index: '',
          access_type: 'public'
        };

        // Process the answers/content from the AI result
        if (postData.answers && Array.isArray(postData.answers)) {
          newPost.answers = postData.answers.map(answer => ({
            content_type: answer.content_type || 'text',
            content: answer.content || '',
            fileList: answer.fileList || [],
            has_titles: answer.has_titles || false,
            is_hidden: answer.is_hidden || false,
            uniqueCode: this.generateUniqueCode(),
            quiz_content: answer.quiz_content || {
              question: '',
              options: ['', '', '', ''],
              correct_answer: '',
              explanation: ''
            }
          }));
        } else if (postData.content) {
          // If it's a single content piece, create one answer
          newPost.answers = [{
            content_type: 'text',
            content: postData.content,
            fileList: [],
            has_titles: false,
            is_hidden: false,
            uniqueCode: this.generateUniqueCode(),
            quiz_content: {
              question: '',
              options: ['', '', '', ''],
              correct_answer: '',
              explanation: ''
            }
          }];
        }

        // Call the API to create the post
        const response = await postRequest('updatePost', newPost);
        
        if (response.data.code === 0) {
          this.$message({
            message: 'Private knowit created successfully! You can find it in your Knowit list.',
            type: 'success',
            duration: 3000
          });

          // Close the AI dialogs
          this.aiDialogVisible = false;
          this.aiDrawerVisible = false;

          // Optionally navigate to the posts list
          // this.$router.push('/my-knowit');
        } else {
          throw new Error(response.data.msg || 'Failed to create private knowit');
        }
      } catch (error) {
        console.error('Error creating private post from AI:', error);
        this.$message({
          message: 'Failed to create private knowit from AI result',
          type: 'error',
          duration: 3000
        });
      }
    },

    submitForm() {
      this.$refs.postForm.validate(async (valid) => {
        if (valid) {
            if (this.isEditing) {
              this.postForm.status = 'PUBLISHED'
        
              await this.updatePost()
              console.log('Updating post:', this.postId, this.postForm)
              this.$message({
                message: 'Knowit updated successfully!',
                duration: 1500
              })
            } else {
              // TODO: Replace with actual API call
              // await createPost(this.postForm)
              console.log('Creating new post:', this.postForm)
              this.$message({
                message: 'Knowit created successfully!',
                duration: 1500
              })
            }
            this.$router.go(-1)

        }
      })
    },

    async safeNavigate(path) {
      try {
        await this.$router.push(path)
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
    },

    async savePost() {
      this.postForm.status = 'PUBLISHED'
      await this.updatePost()
      // localStorage.removeItem('editPostId')
      await this.safeNavigate('/my-knowit')
    },
    
    async saveDraft(status) {
      try {
        this.postForm.status = status
        await this.updatePost()
        // localStorage.removeItem('editPostId')
        console.log('Saving draft:', localStorage.getItem('editPostId'))
        
        this.$message({
          message: 'Draft saved successfully!',
          type: 'success',
          duration: 1500
        })
        
      } catch (error) {
        this.$message({
          message: 'Failed to save draft',
          type: 'error',
          duration: 1500
        })
        console.error('Error saving draft:', error)
      }
    },
    async hidePost() {
      this.postForm.status = 'HIDDEN'
      await this.updatePost()
    },
    confirmDelete() {
      this.deleteDialogVisible = true
    },
    async deletePost() {
      try {
        this.postForm.status = 'DELETED'
        await this.updatePost()
        localStorage.removeItem('editPostId')
        console.log('Deleting post:', this.postId)
        this.$message.success('Knowit deleted successfully!')
        this.deleteDialogVisible = false
        this.$router.push('/my-knowit')
      } catch (error) {
        this.$message.error('Failed to delete knowit')
        console.error('Error deleting post:', error)
      }
    },
    cancel() {
      localStorage.removeItem('editPostId')
      console.log('1'+this.collectionId)
      if (this.collectionId) {
        console.log('2'+this.collectionId)
        localStorage.setItem('editCollectionId', this.collectionId)
        this.$router.push('/new-collection')
        return false
      } else {
        console.log('3'+this.collectionId)
        this.$router.push('/my-knowits')
      }
    },
    addNewAnswer() {
      this.postForm.answers.push({
        content_type: 'text',
        content: '',
        fileList: [],
        has_titles: false,
        is_hidden: false,
        uniqueCode: this.generateUniqueCode(),
        quiz_content: {
          question: '',
          options: ['', '', '', ''],
          correct_answer: '',
          explanation: ''
        }
      })
    },
    removeAnswer(index) {
      this.postForm.answers.splice(index, 1)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      this.$message.warning('Only one file can be uploaded at a time')
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfer of ${file.name} ?`)
    },
    handleContentTypeChange(answer) {
      if (answer.content_type === 'quiz' && !answer.quiz_content) {
        // Initialize quiz_content if it doesn't exist
        this.$set(answer, 'quiz_content', {
          question: '',
          options: ['', '', '', ''],
          correct_answer: '',
          explanation: ''
        })
      }
    },
    openAIDrawer(taskType = null, contextData = null, index = null) {
      console.log('Opening AI drawer with task:', taskType);
      
      // Set the current task (null if no specific task)
      this.currentAITask = taskType;
      
      // If no specific task, just put postForm in context pot without executing anything
      if (!taskType) {
        this.prepareContextPot([this.postForm]);
        this.chain_id = '';
        this.aiDrawerVisible = true;
        return;
      }
      
      // Prepare context pot based on task type
      if (taskType === 'Generate Single Knowit Content') {//OK
        this.prepareContextPot([this.postForm]);
        this.chain_id = '68a72f8d94c784a75b8b4593';
      } else if (taskType === 'Generate Knowit Cards') {//OK
        this.prepareContextPot([this.postForm]);
        this.chain_id = '68a72f8c94c784ad5b8b459c';
      } else if (taskType === 'Generate on Custom Material') {//OK
        this.prepareContextPot([this.postForm]);
        this.chain_id = '68a72f8e94c784b15b8b4594';
      } else if (taskType === 'Improve Single Knowit Content') {//OK
        console.log('Improve Single Post Content, index: ', index);
        this.aiAnswerEditIndex = index;
        this.prepareContextPot([this.postForm]);
        this.chain_id = '68a72f8d94c784a45b8b4592';
      }
      
      // Open AI drawer
      this.aiDrawerVisible = true;
    },

    handleAITask(task, index = null) {
      // Call openAIDrawer with the specific task and index
      this.openAIDrawer(task, null, index);
    },
    async handleAIResult(result, type=null) {
      console.log('Received AI result:', result);
      
      // Helper function to initialize answer properties
      const initializeAnswer = (answer) => {
        if (!answer.is_hidden) {
          this.$set(answer, 'is_hidden', false);
        }
        if (!answer.has_titles) {
          this.$set(answer, 'has_titles', false);
        }
        if (!answer.fileList) {
          this.$set(answer, 'fileList', []);
        }
        if (answer.content_type === 'quiz' && !answer.quiz_content) {
          this.$set(answer, 'quiz_content', {
            question: '',
            options: ['', '', '', ''],
            correct_answer: '',
            explanation: ''
          });
        }
        if (!answer.uniqueCode) {
          answer.uniqueCode = this.generateUniqueCode();
        }
        return answer;
      };

      if (result) {
        if (this.currentAITask === 'Generate Knowit Cards' || this.currentAITask === 'Generate on Custom Material') {
          // Initialize properties for all answers
          let processedAnswers = result.map(answer => initializeAnswer(answer));
          this.postForm.answers = processedAnswers;
        } else if (this.currentAITask === 'Generate Single Knowit Content') {
          // Initialize properties for the new answer
          this.postForm.answers.push(initializeAnswer(result));
        } else if (this.currentAITask === 'Improve Single Knowit Content') {
          if (type === 'update') {
            // Initialize properties for the updated answer
            console.log('Improve Single Post Content, result: ', result)
            this.postForm.answers[this.aiAnswerEditIndex] = initializeAnswer(result[0]);
            console.log('Improve Single Post Content, initializeAnswer: ', initializeAnswer(result[0]))
          } else if (type === 'insert') {
            // Initialize properties for all new answers
            var startIndex = this.aiAnswerEditIndex+1;
            result.forEach(item => {
              this.postForm.answers.splice(startIndex++, 0, initializeAnswer(item));
            });
          }
        } else if (type === 'createPrivatePost') {
          // This is now handled directly in UserAIDialogue component
          // No need to handle it here anymore
          return; // Exit early to avoid closing dialogs
        }
      }
      this.aiDialogVisible = false;
      this.aiDrawerVisible = false;
    },
    showInsertButton(index) {
      this.activeInsertIndex = index;
    },

    hideInsertButton() {
      this.activeInsertIndex = null;
    },

    addNewAnswerAt(index) {
      const newAnswer = {
        content_type: 'text',
        content: '',
        fileList: [],
        has_titles: false,
        is_hidden: false,
        uniqueCode: this.generateUniqueCode(),
        quiz_content: {
          question: '',
          options: ['', '', '', ''],
          correct_answer: '',
          explanation: ''
        }
      };
      this.postForm.answers.splice(index, 0, newAnswer);
    },
    showResortDialog() {
      // Create a deep copy of answers for sorting
      this.sortableAnswers = JSON.parse(JSON.stringify(this.postForm.answers));
      this.resortDialogVisible = true;
      
      // Initialize draggable after dialog is shown
      this.$nextTick(() => {
        const tbody = document.querySelector('.el-table__body-wrapper tbody');
        if (tbody) {
          new Sortable(tbody, {
            handle: '.el-icon-rank',
            animation: 150,
            onEnd: ({ newIndex, oldIndex }) => {
              const row = this.sortableAnswers.splice(oldIndex, 1)[0];
              this.sortableAnswers.splice(newIndex, 0, row);
            }
          });
        }
      });
    },
    applyResort() {
      // Apply the new order to the actual answers
      this.postForm.answers = [...this.sortableAnswers];
      this.resortDialogVisible = false;
    },
    getAutoSaveKey() {
      const userId = this.$store.state.user_id || 'anonymous';
      return `post_auto_save_${userId}_${this.postId || 'new'}`;
    },
    cleanupOldAutoSaveCaches() {
      // Clean up old cache entries that don't have user_id prefix
      const oldKey = `post_auto_save_${this.postId || 'new'}`;
      localStorage.removeItem(oldKey);

      // Also clean up any cache entries from other users for this post
      const currentUserId = this.$store.state.user_id;
      if (!currentUserId) return;

      Object.keys(localStorage).forEach(key => {
        // Match pattern: post_auto_save_{userId}_{postId}
        if (key.startsWith('post_auto_save_') && key !== this.getAutoSaveKey()) {
          const postIdPart = this.postId || 'new';
          // If this cache is for the same post but different user, remove it
          if (key.endsWith(`_${postIdPart}`) && !key.includes(`_${currentUserId}_`)) {
            localStorage.removeItem(key);
          }
        }
      });
    },
    saveAutoSaveCache() {
      console.log('saveAutoSaveCache', this.postForm)
      localStorage.setItem(this.getAutoSaveKey(), JSON.stringify(this.postForm));
    },
    clearAutoSaveCache() {
      localStorage.removeItem(this.getAutoSaveKey());
    },
    loadAutoSaveCache() {
      const cache = localStorage.getItem(this.getAutoSaveKey());
      return cache ? JSON.parse(cache) : null;
    },
    debounceAutoSave() {
      if (this.autoSaveDebounceTimer) clearTimeout(this.autoSaveDebounceTimer);
      this.autoSaveDebounceTimer = setTimeout(() => {
        this.saveAutoSaveCache();
      }, 1000);
    },
    async checkAutoSavePrompt() {
      const cache = this.loadAutoSaveCache();
      if (cache) {
        try {
          await this.$confirm(
            'An auto-saved version of this stack was found. Do you want to load it?',
            'Auto-Save Detected',
            {
              confirmButtonText: 'Load Auto-Saved',
              cancelButtonText: 'Ignore',
              type: 'info'
            }
          );
          // User confirmed, load cache
          Object.assign(this.postForm, cache);
          this.$message.success('Auto-saved version loaded!');
        } catch (e) {
          // User cancelled, do nothing
        }
      }
    },
    getHtmlWithImgStyle(html) {
      const imgStyle = '<style>.preview-text img { width: 100% !important; height: auto !important; display: block; max-width: 100%; }</style>';
      return imgStyle + html;
    },

    editAnswer(index) {
      this.editingAnswerIndex = index;
      this.editingAnswer = JSON.parse(JSON.stringify(this.postForm.answers[index]));
      this.editCardDialogVisible = true;
    },

    updateAnswer(index, updatedAnswer) {
      // Preserve uniqueCode and is_hidden when updating from AI fix
      const updatedCard = {
        ...updatedAnswer,
        uniqueCode: this.postForm.answers[index].uniqueCode || this.generateUniqueCode(),
        is_hidden: this.postForm.answers[index].is_hidden || false
      };
      this.$set(this.postForm.answers, index, updatedCard);
    },

    async handleFixByAIForCard(index) {
      // Open dialog and start AI processing
      this.fixingCardIndex = index
      this.fixingCardData = JSON.parse(JSON.stringify(this.postForm.answers[index])) // Deep clone
      this.showComparisonDialog = true
      this.isLoadingAI = true
      this.aiResponse = null

      try {
        // Convert answer data to JSON string
        const answerJSON = JSON.stringify(this.postForm.answers[index]);

        // The prompt to use for fixing quiz defects
        const systemPrompt = `You are a JSON validator. You will receive a JSON object representing a quiz.

OUTPUT FORMAT - You must return EXACTLY one of these two options:

Option 1: If NO defects found, return exactly:
true

Option 2: If defects found, return the corrected JSON with this EXACT structure:
{"content_type":"quiz","content":"","fileList":[],"quiz_content":{"question":"your question here","options":["option1","option2","option3","option4"],"correct_answer":"B","explanation":"your explanation"},"is_hidden":false}

VALIDATION RULES:
- Check if quiz options are relevant and have a correct answer
- Verify the correct_answer is actually correct
- Ensure explanation is relevant
- Verify key names match: content_type, content, quiz_content, question, options, correct_answer, explanation

CRITICAL RULES:
- Return ONLY raw JSON or the word "true"
- NO markdown (no ###, no **, no formatting)
- NO explanatory text
- NO code blocks (\`\`\`json)
- NO extra fields or comments`;

        // Call AI API
        const response = await postRequest('exeModelGeneral', {
          user_id: this.$store.state.user_id,
          model: 'siliconflow/deepseek-ai/DeepSeek-V3',
          content: answerJSON,
          user_input: systemPrompt,
          source_label: 'Fix Quiz By AI'
        });

        if (response && response.data && response.data.code === 0) {
          this.aiResponse = response.data.data;
        } else {
          this.$message.error('Failed to get AI response');
          this.showComparisonDialog = false;
        }
      } catch (error) {
        console.error('Error fixing by AI:', error);
        this.$message.error('Failed to fix by AI: ' + error.message);
        this.showComparisonDialog = false;
      } finally {
        this.isLoadingAI = false;
      }
    },

    confirmAIFix() {
      if (!this.aiResponse || this.fixingCardIndex === null) return

      // Check if AI found no defects
      if (this.aiResponse.trim().toLowerCase() === 'true') {
        this.$message.success('No defects found! This card is already correct.')
        this.showComparisonDialog = false
        return
      }

      // Try to parse the revised JSON
      try {
        const revisedAnswer = JSON.parse(this.aiResponse)
        // Update the card
        this.updateAnswer(this.fixingCardIndex, revisedAnswer)
        this.$message.success('Card has been fixed by AI!')
        this.showComparisonDialog = false
      } catch (parseError) {
        console.error('Failed to parse AI response:', parseError)
        this.$message.error('Failed to parse AI response. Please try again.')
      }
    },

    cancelAIFix() {
      this.showComparisonDialog = false
      this.aiResponse = null
      this.isLoadingAI = false
      this.fixingCardIndex = null
      this.fixingCardData = null
    },

    // AI Modify Text Card Methods
    openAIModifyDialog(index) {
      this.modifyingCardIndex = index
      this.modifyingCardData = JSON.parse(JSON.stringify(this.postForm.answers[index]))
      this.aiModifyInstruction = ''
      this.aiModifyResponse = null
      this.isLoadingAIModify = false
      this.showAIModifyDialog = true
    },

    async executeAIModify() {
      if (!this.aiModifyInstruction || this.aiModifyInstruction.trim() === '') {
        this.$message.warning('Please enter a modification instruction')
        return
      }

      this.isLoadingAIModify = true
      this.aiModifyResponse = '' // Set to empty string to show comparison view

      try {
        const systemPrompt = `You are a content editor. Your task is to modify the given text content based on the user's instruction.

USER INSTRUCTION: ${this.aiModifyInstruction}

RULES:
- Apply the user's requested modification to the content
- Maintain the original format (markdown, plain text, etc.) unless the instruction requires format changes
- Return ONLY the modified content, no explanations or additional text
- If the content uses markdown formatting, preserve or enhance the markdown as appropriate
- Keep the content relevant and coherent`

        const response = await postRequest('exeModelGeneral', {
          model: 'siliconflow/deepseek-ai/DeepSeek-V3',
          content: this.modifyingCardData.content,
          user_input: systemPrompt,
          source_label: 'AI Modify Text Card'
        })

        if (response && response.data && response.data.code === 0) {
          this.aiModifyResponse = response.data.data
        } else {
          this.$message.error('Failed to get AI response')
          this.aiModifyResponse = null
        }
      } catch (error) {
        console.error('Error modifying by AI:', error)
        this.$message.error('Failed to modify by AI: ' + error.message)
        this.aiModifyResponse = null
      } finally {
        this.isLoadingAIModify = false
      }
    },

    resetAIModify() {
      this.aiModifyResponse = null
      this.isLoadingAIModify = false
    },

    applyAIModify() {
      if (!this.aiModifyResponse || this.modifyingCardIndex === null) return

      // Update the card content
      const updatedCard = {
        ...this.postForm.answers[this.modifyingCardIndex],
        content: this.aiModifyResponse
      }
      this.$set(this.postForm.answers, this.modifyingCardIndex, updatedCard)
      this.$message.success('Card has been modified by AI!')
      this.cancelAIModify()

      // Auto-save if editing
      if (this.isEditing && this.postId) {
        this.autoSavePost()
      }
    },

    cancelAIModify() {
      this.showAIModifyDialog = false
      this.modifyingCardIndex = null
      this.modifyingCardData = null
      this.aiModifyInstruction = ''
      this.aiModifyResponse = null
      this.isLoadingAIModify = false
    },

    async updateSummaryByAI() {
      if (this.postForm.answers.length === 0) {
        this.$message.warning('No cards available to summarize')
        return
      }

      this.isGeneratingSummary = true

      try {
        // Prepare post data for summary generation
        const postData = {
          title: this.postForm.title,
          answers: this.postForm.answers
        }

        console.log('=== Sending to generatePostContentSummary ===')
        console.log('Post title:', postData.title)
        console.log('Number of answers:', postData.answers.length)
        console.log('First 3 answers:', postData.answers.slice(0, 3))

        // Use axios directly with extended timeout for AI generation
        const response = await axios.post('./index.php', {
          function: 'generatePostContentSummary',
          post: postData,
          save_to_post: false
        }, {
          timeout: 300000 // 5 minutes timeout for AI processing
        })

        console.log('=== Response from generatePostContentSummary ===')
        console.log('Full response:', response.data)
        console.log('Response code:', response.data.code)
        console.log('Response data:', response.data.data)
        console.log('Response data length:', response.data.data ? response.data.data.length : 0)
        console.log('Response data JSON:', JSON.stringify(response.data.data))
        console.log('Debug info:', response.data.debug)

        if (response && response.data && response.data.code === 0) {
          const summaryData = response.data.data

          // Check if the summary is just whitespace
          if (!summaryData || summaryData.trim() === '') {
            console.error('Backend returned empty or whitespace-only summary')
            console.error('Backend debug info:', response.data.debug)
            this.$message.error('Backend returned empty summary. Check console for debug info.')
            return
          }

          this.postForm.content_summary = summaryData
          this.$message.success('Content summary generated successfully!')
        } else {
          console.error('Summary generation failed')
          console.error('Response:', response.data)
          console.error('Debug info:', response.data.debug)
          this.$message.error('Failed to generate summary: ' + (response.data.msg || 'Unknown error') + '. Check console for details.')
        }
      } catch (error) {
        console.error('Error generating summary:', error)
        if (error.code === 'ECONNABORTED') {
          this.$message.error('Request timeout - the summary generation took too long. Please try again.')
        } else if (error.response) {
          this.$message.error('Failed to generate summary: ' + (error.response.data.msg || error.message))
        } else {
          this.$message.error('Failed to generate summary: ' + error.message)
        }
      } finally {
        this.isGeneratingSummary = false
      }
    },

    async saveEditedAnswer(cardData) {
      if (this.editingAnswerIndex !== null) {
        const updatedCard = {
          ...cardData,
          uniqueCode: this.postForm.answers[this.editingAnswerIndex].uniqueCode || this.generateUniqueCode(),
          is_hidden: cardData.is_hidden !== undefined ? cardData.is_hidden : false,
          has_titles: cardData.has_titles || false
        };
        this.$set(this.postForm.answers, this.editingAnswerIndex, updatedCard);

        // Auto-save the entire post to persist the change
        if (this.isEditing && this.postId) {
          this.isSaving = true; // Show loading indicator on "Save In Deck" button
          try {
            await this.updatePost(true); // Pass true for silent save
            this.$message.success('Card updated and saved');
          } catch (error) {
            console.error('Error auto-saving card edit:', error);
            this.$message.error('Card updated locally but failed to save to server. Please click "Save in Deck" manually.');
          } finally {
            this.isSaving = false; // Hide loading indicator
          }
        }
      }
      this.closeEditDialog();
    },

    closeEditDialog() {
      this.editCardDialogVisible = false;
      this.editingAnswer = null;
      this.editingAnswerIndex = null;
    },

    prepareContextPot(elements) {
      // Clear existing context pot
      this.$store.dispatch('contextPot/clearAll');
      
      // Add elements to context pot
      elements.forEach(element => {
        this.$store.dispatch('contextPot/addItem', element);
      });
    },

    clearContextPot() {
      this.$store.dispatch('contextPot/clearAll').then(result => {
        if (result.success) {
          this.$message.success(result.message);
        }
      });
    },

    removeFromContextPot(index) {
      this.$store.dispatch('contextPot/removeItem', index).then(result => {
        if (result.success) {
          this.$message.info(result.message);
        }
      });
    },

    getAIContextString() {
      return JSON.stringify({
        task: this.currentAITask,
        post_id: this.postId,
        post_title: this.postForm.title,
        post_description: this.postForm.description,
        post_answers: this.postForm.answers,
        collection_context: this.collectionContextString,
        user_id: this.$store.state.user_id,
      });
    },

    handleDrawerClose() {
      this.aiDrawerVisible = false;
      this.currentAITask = null;
    }
  },
  watch: {
    postForm: {
      handler: 'debounceAutoSave',
      deep: true
    }
  }
}
</script>

<style scoped>
.new-post-container {
  width: 100% !important; /* Force width with !important */
  min-width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.page-header {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0;
  margin-top: 60px;
  margin-bottom: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.el-header {
  text-align: center;
  padding: 0;
  height: fit-content !important;
}

.el-form {
  width: 100% !important;
  min-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.answers-container {
  width: 100%;
  margin: 20px 0;
}

.answers-scroll {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0px 0;
  margin-bottom: 20px;
}

.answer-card {
  width: 100%;
  height: 600px;
  overflow: hidden;
}

.card-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  overflow: hidden;
}

.preview-section {
  margin: 10px;
  width: 360px;
  height: 480px;
  padding: 0px;
  background: #f8f9fa;
  overflow-y: auto;
  flex-shrink: 0;
}

.preview-card {
  
  padding: 20px;
  border-radius: 0px;
  margin: 10px;
  
  
}

.preview-text {
  width: 100%;
  height: 100%;
  line-height: 1.5;
}

.preview-media {
  display: flex;
  justify-content: left;
  align-items: left;
}

.preview-image, .preview-video {
  max-width: 100%;
  
  object-fit: contain;
}

.preview-audio {
  width: 100%;
}

.quiz-question {
  font-weight: bold;
  margin-bottom: 15px;
  line-height: 1.5;
}

.quiz-option {
  padding: 0 10px;
  margin: 10px 0;
  border-radius: 4px;
  background: white;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 40px;
  height: auto;
  word-wrap: break-word;
  word-break: break-word;
}

.correct-option {
  background: #f0f9eb;
  border-color: #67c23a;
  color: #67c23a;
}

.content-type {
  margin-bottom: 20px;
  margin-left: 8px;
}

.content-input {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.content-input :deep(.el-form-item__content) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.full-height-textarea {
  flex: 1;
  display: flex;
}

.full-height-textarea :deep(.el-textarea) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.full-height-textarea :deep(.el-textarea__inner) {
  flex: 1;
  resize: none;
}

:deep(.v-note-wrapper) {
  z-index: 1 !important;
}

.add-content-btn {
  margin: 20px auto;
  display: block;
}

:deep(.el-form-item__label) {
  padding: 0;
  line-height: 1.5;
  margin-bottom: 8px;
}

:deep(.el-form-item) {
  margin-bottom: 24px;
  flex-shrink: 0;
}


.el-card__body {
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  padding: 20px;
}



.content-input {
  margin-bottom: 0;
}

.answer-card, .el-card__body {
  display: block;
}

/* Override Element UI's default styles */
:deep(.el-card__body) {
  height: 100%;
  padding: 0;
}



.content-input {
  margin-bottom: 0;
}

.query-params {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
}

.info-icon {
  margin-left: 4px;
  color: #909399;
  cursor: help;
}

/* .quiz-option {
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
} */

.correct-answer {
  background-color: #f0f9eb;
  border-color: #67c23a;
  color: #67c23a;
}

.quiz-solution {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.correct-answer-label {
  font-weight: bold;
  color: #67c23a;
  margin-bottom: 10px;
}

.explanation-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.option-label {
  font-weight: bold;
  margin-right: 8px;
}

:deep(.v-note-wrapper) {
  z-index: 1 !important;
}

:deep(.markdown-body) {
  height: 100%;
}

.full-height-textarea {
  width: 100%;
  border-radius: 4px;
}

.fixed-header {
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.fixed-header-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fixed-header :deep(.el-form-item) {
  margin: 0 !important;
}

.fixed-header :deep(.el-select) {
  width: 150px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  
}

.header-buttons {
  display: flex;
  gap: 10px;
  padding:10px;
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 10px;
  
}

.status-label {
  font-size: 14px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 5px;
}

.status-label i {
  margin-right: 4px;
}

.el-main {
  width: 100% !important;
  min-width: 100%;
  padding-top: 80px;
  box-sizing: border-box;
}

.button-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
}

.add-content-btn {
  margin: 0;  /* Override the previous margin */
}

.quiz-explanation {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.explanation-header {
  font-weight: bold;
  color: #409eff;
  margin-bottom: 8px;
}

.explanation-content {
  line-height: 1.5;
  color: #606266;
}

.content-container {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
}

.scrollable-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}

.quiz-options {
  margin-bottom: 20px;
}

.quiz-option {
  margin-bottom: 10px;
}

.quiz-explanation {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.answer-card {
  height: 600px;
  overflow: hidden;
}

.card-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  overflow: hidden;
}

.ai-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-assist-btn {
  width: 100%;
  white-space: normal;
  height: auto;
  padding: 10px;
  line-height: 1.4;
}

.content-panel-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.quiz-section {
  max-height: 350px;
  overflow-y: auto;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.quiz-section :deep(.el-form-item) {
  margin-bottom: 15px;
  flex-shrink: 0;
}

.quiz-section :deep(.el-form-item__content) {
  margin-top: 5px;
}

.insert-section {
  height: 20px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: height 0.3s;
}

.insert-section:hover {
  height: 40px;
}

.insert-button {
  transform: scale(0.9);
  transition: transform 0.2s;
}

.insert-button:hover {
  transform: scale(1);
}

.preview-text img {
  width: 100% !important;
  height: auto !important;
  display: block;
  max-width: 100%;
}

/* Grid Layout Styles */
.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
  flex-wrap: wrap;
}

.header-left-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
}

.cards-stats-inline {
  margin-left: 16px;
  display: inline-flex;
  gap: 16px;
  font-size: 13px;
}

.stat-item-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.stat-label-inline {
  color: #909399;
  font-weight: normal;
}

.stat-value-inline {
  font-weight: 600;
  color: #409eff;
  font-size: 14px;
}

.stat-value-inline.cryptic {
  color: #e6a23c;
}

.card-type-filter {
  display: flex;
  align-items: center;
}

.layout-switcher {
  display: flex;
  align-items: center;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  padding: 0;
  width: 100%;
  align-items: start;
}

.card-item {
  width: 100%;
  aspect-ratio: 1 / 1.618; /* Golden ratio for portrait cards */
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease;
  cursor: move;
  position: relative;
}

.card-item :deep(.post-answer-view) {
  height: 100%;
}

.card-item :deep(.answer-container) {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.card-item :deep(.answer-content) {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

/* Full-cover image background styling for image-type answers */
.card-item :deep(.image-content) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.card-item :deep(.image-content img) {
  width: 100%;
  height: 100%;
  max-height: none;
  object-fit: cover;
  object-position: center;
  border-radius: 0;
}

/* Darken image slightly and add overlay for better text visibility */
.card-item :deep(.image-content)::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0.3) 100%
  );
  pointer-events: none;
}

/* Position footer and hidden indicator above the image - only for image cards */
.card-item:has(.image-content) :deep(.answer-footer),
.card-item:has(.image-content) :deep(.hidden-indicator) {
  position: relative;
  z-index: 2;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.card-item :deep(.floating-actions) {
  z-index: 3;
}

.card-item:hover {
  transform: translateY(-2px);
}

/* Drag and drop styles */
.sortable-ghost {
  opacity: 0.4;
  background-color: #f0f0f0;
}

.sortable-chosen {
  cursor: grabbing !important;
}

.sortable-drag {
  opacity: 0.8;
  transform: rotate(2deg);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  background-color: #fafafa;
}

.empty-state p {
  margin-bottom: 24px;
  font-size: 16px;
  color: #606266;
}

.empty-state .el-button {
  padding: 12px 24px;
  font-size: 14px;
  border-radius: 6px;
}

/* Paragraph Layout Styles */
.paragraph-layout {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.paragraph-item {
  padding: 24px 0;
  border-bottom: 2px solid #e8e8e8;
  position: relative;
  cursor: move;
}

.paragraph-item:last-child {
  border-bottom: none;
}

.paragraph-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.paragraph-number {
  font-size: 16px;
  font-weight: 600;
  color: #409eff;
}

.paragraph-actions {
  display: flex;
  gap: 8px;
}

.paragraph-content {
  padding: 0 8px;
  line-height: 1.8;
  font-size: 15px;
  color: #333;
}

.paragraph-content .text-content {
  max-width: 100%;
  word-wrap: break-word;
}

.paragraph-content .text-content :deep(p) {
  margin: 12px 0;
  line-height: 1.8;
}

.paragraph-content .text-content :deep(h1),
.paragraph-content .text-content :deep(h2),
.paragraph-content .text-content :deep(h3),
.paragraph-content .text-content :deep(h4),
.paragraph-content .text-content :deep(h5),
.paragraph-content .text-content :deep(h6) {
  margin: 20px 0 12px 0;
  font-weight: 600;
}

.paragraph-content .text-content :deep(ul),
.paragraph-content .text-content :deep(ol) {
  margin: 12px 0;
  padding-left: 24px;
}

.paragraph-content .text-content :deep(li) {
  margin: 6px 0;
}

.paragraph-content .text-content :deep(blockquote) {
  margin: 16px 0;
  padding: 12px 16px;
  border-left: 4px solid #409eff;
  background-color: #f5f7fa;
  color: #606266;
}

.paragraph-content .text-content :deep(code) {
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
}

.paragraph-content .text-content :deep(pre) {
  margin: 16px 0;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  overflow-x: auto;
}

.paragraph-content .image-content {
  position: relative;
  width: 100%;
  min-height: 400px;
  max-height: 600px;
  margin: 16px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.paragraph-content .image-content img {
  width: 100%;
  height: 100%;
  min-height: 400px;
  max-height: 600px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
}

.paragraph-content .video-content video {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 16px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.paragraph-content .quiz-content {
  margin: 16px 0;
  padding: 20px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.paragraph-content .quiz-question {
  font-size: 16px;
  margin-bottom: 16px;
  color: #333;
}

.paragraph-content .quiz-option {
  display: flex;
  gap: 8px;
  padding: 10px;
  margin: 8px 0;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  justify-content: flex-start;
  align-items: flex-start;
}

.paragraph-content .quiz-explanation {
  margin-top: 16px;
  padding: 12px;
  background-color: #fff9e6;
  border-radius: 6px;
  border-left: 4px solid #ffc107;
}

.paragraph-content .hidden-indicator {
  margin-top: 12px;
}

/* Content Summary Section */
.content-summary-section {
  margin-top: 40px;
  padding: 24px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 2px dashed #d0d0d0;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.summary-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content-summary-section :deep(.el-textarea__inner) {
  font-size: 14px;
  line-height: 1.8;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: border-color 0.3s;
}

.content-summary-section :deep(.el-textarea__inner:focus) {
  border-color: #409eff;
}

.summary-note {
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background-color: #e6f7ff;
  border-left: 3px solid #409eff;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.6;
}

.summary-note i {
  color: #409eff;
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

/* AI Post Drawer Styles */
:deep(.ai-post-drawer) {
  z-index: 2000 !important;
}

:deep(.el-drawer__wrapper) {
  z-index: 2000 !important;
}

:deep(.ai-post-drawer .el-drawer__body) {
  padding: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Ensure drawer is visible and above other elements */
:deep(.el-drawer) {
  z-index: 2000 !important;
}

:deep(.el-drawer__container) {
  z-index: 2000 !important;
}

/* Floating AI Button Styles */
.floating-ai-button {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 16px 12px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-height: 80px;
  justify-content: center;
}

.floating-ai-button:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  transform: translateY(-50%) translateX(-4px);
  box-shadow: -4px 4px 15px rgba(0, 0, 0, 0.3);
}

.floating-ai-button i {
  font-size: 20px;
  margin-bottom: 4px;
}

.floating-ai-button span {
  font-size: 12px;
  font-weight: 500;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  white-space: nowrap;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .card-item {
    /* Maintain golden ratio on mobile */
    aspect-ratio: 1 / 1.618;
    max-width: 100%;
  }

  .tab-header {
    flex-direction: column;
    align-items: stretch;
  }

  .header-left-actions {
    width: 100%;
    flex-direction: column;
  }

  .card-type-filter {
    width: 100%;
    justify-content: center;
    margin-top: 12px;
  }

  .card-type-filter .el-select {
    width: 100% !important;
  }

  .layout-switcher {
    width: 100%;
    justify-content: center;
    margin-top: 12px;
  }

  .tab-header .el-button {
    margin-bottom: 8px;
  }

  .paragraph-item {
    padding: 16px 0;
  }

  .paragraph-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .paragraph-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .paragraph-content .image-content {
    min-height: 300px;
    max-height: 450px;
  }

  .paragraph-content .image-content img {
    min-height: 300px;
    max-height: 450px;
  }
}

/* Comparison Dialog Styles */
.comparison-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin: 20px 0;
}

.comparison-column {
  display: flex;
  flex-direction: column;
}

.comparison-column h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 12px;
  border-bottom: 2px solid #e0e0e0;
}

.card-preview {
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
}

.quiz-display {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quiz-question-display {
  font-size: 15px;
  line-height: 1.6;
  color: #303133;
}

.quiz-question-display strong {
  color: #409EFF;
  display: block;
  margin-bottom: 8px;
}

.quiz-options-display {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quiz-option-display {
  padding: 12px 16px;
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  transition: all 0.2s;
}

.quiz-option-display.correct {
  background: #f0f9ff;
  border-color: #67c23a;
  border-width: 2px;
}

.quiz-option-display i {
  color: #67c23a;
  font-size: 18px;
}

.quiz-explanation-display {
  padding: 12px;
  background: #fff9e6;
  border-left: 4px solid #409EFF;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.6;
}

.quiz-explanation-display strong {
  color: #409EFF;
  display: block;
  margin-bottom: 6px;
}

.loading-state,
.no-defects-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
}

.loading-state p,
.error-state p {
  margin-top: 16px;
  color: #606266;
  font-size: 14px;
}

@media (max-width: 768px) {
  .comparison-container {
    grid-template-columns: 1fr;
  }
}

/* AI Modify Dialog Styles */
.ai-modify-container {
  min-height: 300px;
}

.ai-modify-instruction {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.original-content-preview h4,
.instruction-input h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.content-preview-box {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  max-height: 200px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
}

.instruction-input .el-textarea {
  font-size: 14px;
}
</style> 